import { Layout } from 'src/components/layout/layout';
import { QualifyProperty } from 'src/components/QualifyPropertyHabi';
import ImportHistory from 'src/components/QualifyPropertyHabi/ImportHistory/ImportHistory';

const QualifyPropertyHabiPage = () => {
    return (
        <Layout>
            <QualifyProperty />
            <ImportHistory />
        </Layout>
    );
};

export default QualifyPropertyHabiPage;
